import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "oshow_big"
};
const _hoisted_2 = {
  class: "order_box"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "order_box about_show"
};
const _hoisted_5 = {
  key: 0,
  class: "form_button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_nav_bar, {
    title: "充值详情",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), _createElementVNode("div", _hoisted_1, [_cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "title_s"
  }, "充值信息", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("dl", null, [_cache[0] || (_cache[0] = _createElementVNode("dt", null, "订单号", -1)), _createElementVNode("dd", null, _toDisplayString($setup.orderInfo.id), 1)]), _createElementVNode("dl", null, [_cache[1] || (_cache[1] = _createElementVNode("dt", null, "充值金额", -1)), _createElementVNode("dd", null, "￥" + _toDisplayString($setup.orderInfo.price), 1)]), _createElementVNode("dl", null, [_cache[2] || (_cache[2] = _createElementVNode("dt", null, "付款方式", -1)), _createElementVNode("dd", null, _toDisplayString($setup.orderInfo.pay_name), 1)]), _createElementVNode("dl", null, [_cache[3] || (_cache[3] = _createElementVNode("dt", null, "付款时间", -1)), _createElementVNode("dd", null, _toDisplayString($setup.orderInfo.pay_time), 1)]), _createElementVNode("dl", null, [_cache[4] || (_cache[4] = _createElementVNode("dt", null, "充值状态", -1)), _createElementVNode("dd", null, _toDisplayString($setup.orderInfo.sname), 1)]), _createElementVNode("dl", null, [_cache[5] || (_cache[5] = _createElementVNode("dt", null, "提交时间", -1)), _createElementVNode("dd", null, _toDisplayString($setup.orderInfo.uptime), 1)]), $setup.orderInfo.status == 1 ? (_openBlock(), _createElementBlock("dl", _hoisted_3, [_cache[6] || (_cache[6] = _createElementVNode("dt", null, "审核时间", -1)), _createElementVNode("dd", null, _toDisplayString($setup.orderInfo.pass_time), 1)])) : _createCommentVNode("", true)]), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "title_s"
  }, "充值说明", -1)), _createElementVNode("div", _hoisted_4, _toDisplayString($setup.orderInfo.about), 1), $setup.orderInfo.show_del ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_van_button, {
    type: "primary",
    round: "",
    block: "",
    to: "/recharge/edit?id=" + $setup.id
  }, {
    default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("修改充值")])),
    _: 1
  }, 8, ["to"])]), _createElementVNode("li", null, [_createVNode(_component_van_button, {
    type: "danger",
    round: "",
    block: "",
    onClick: $setup.delInfo
  }, {
    default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("删除充值")])),
    _: 1
  }, 8, ["onClick"])])])])) : _createCommentVNode("", true)])], 64);
}